module.exports = __webpack_public_path__ + "img/galeria.5b630460.png";